import React, { Fragment, useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from "react-router-dom";
import { Whatsapp } from 'react-bootstrap-icons';
import ArrowUp from '../../assets/svg/ArrowUp.jsx';

import Tippy from '@tippyjs/react';
import ContactUsWA from '../../components/contact/contact-us-wa';
import styles from '../../assets/css/module/common/common.module.css'
import ContextProvider from '../context/context-master';

const Layout = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [modalWA, setModalWA] = useState(false)
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };


  const toggleWA = () => setModalWA(!modalWA);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);
  return (
    <Fragment>
      <ContextProvider >
        <div className={`${styles['default-layout']}`}>
          <section className={`${styles['sec-header']}`}><Header /></section>
          <section>
            <main className={`${styles['main']}`}>
              <Outlet />
            </main>
          </section>
          <section><Footer /></section>
          <div className={`${styles['floating-btn-container']}`}>
            {
              isVisible ?
                <Tippy content="Bak to Top" placement="left">
                  <div className={`${styles['back-top']} ${styles['btn']}`} onClick={scrollToTop}>
                    <ArrowUp onClick={scrollToTop} />
                  </div>
                </Tippy>
                : null
            }
            <Tippy content="Whatsapp" placement="left">
              <div className={`${styles['wa-button']} ${styles['btn']}`}>
                <Whatsapp onClick={toggleWA} />
              </div>
            </Tippy>
          </div>
        </div>
      </ContextProvider>

      {
        modalWA ?
          <ContactUsWA
            modal={modalWA}
            toggleHandler={toggleWA}
          /> : null
      }
    </Fragment>
  )
}

export default Layout;